import {
  Stripe,
  loadStripe,
  ConfirmUsBankAccountSetupData,
  SetupIntentResult,
  CollectBankAccountTokenResult,
  CollectBankAccountForSetupOptions
} from "@stripe/stripe-js";

let instance: StripeInstance | undefined;

class StripeInstance {
  private stripe: Stripe | null = null;
  private stripePromise: Promise<Stripe | null>;

  constructor(stripeAccount: string) {
    const publishableKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;
    // const apiVersion = process.env.REACT_APP_STRIPE_API_VERSION;

    if (!publishableKey) {
      throw new Error(
        "Stripe publishable key and API version must be set in environment variables."
      );
    }

    // Store the promise in stripePromise to await it in ensureStripe
    this.stripePromise = loadStripe(publishableKey, {
      stripeAccount
      // apiVersion
    }).then((stripe) => {
      this.stripe = stripe;
      return stripe;
    });
  }

  private async ensureStripe(): Promise<Stripe> {
    if (!this.stripe) {
      await this.stripePromise;
    }
    if (!this.stripe) {
      throw new Error("Stripe has not been initialized. Please try again later.");
    }
    return this.stripe;
  }

  async collectBankAccountForSetup(
    params: CollectBankAccountForSetupOptions
  ): Promise<SetupIntentResult | null> {
    const stripe = await this.ensureStripe();
    return stripe.collectBankAccountForSetup(params);
  }

  async confirmUsBankAccountSetup(
    clientSecret: string,
    params: ConfirmUsBankAccountSetupData
  ): Promise<SetupIntentResult | null> {
    const stripe = await this.ensureStripe();
    return stripe.confirmUsBankAccountSetup(clientSecret, params);
  }

  async collectBankAccountToken(
    clientSecret: string
  ): Promise<CollectBankAccountTokenResult | null> {
    const stripe = await this.ensureStripe();
    return stripe.collectBankAccountToken({ clientSecret });
  }
}

export default {
  getInstance(stripeAccount: string): StripeInstance {
    if (!instance) {
      instance = new StripeInstance(stripeAccount);
    }
    return instance;
  }
};
